export class ModeloError {
    id: number;
    error: string;
}
